import {
  SearchTaskRequestTaskDue,
  SearchTaskRequest,
  Stages,
  States,
} from '@urbanx/agx.activities.client';
import { normalizeAgencyFilterState } from 'utils/agencyUtils';
import { AvailableStatesForTasks } from './AvailableStatesForTasks';
import { AvailableStageCategories } from './AvailableTaskCategories';

export type TaskFilterState = Omit<
  SearchTaskRequest,
  'pageSize' | 'previousPageNumber' | 'requireQueryCount' | 'continuationToken'
>;

type StoredTaskFilterState = TaskFilterState & {
  agencyValues?: string[];
};

export const defaultFilterState: TaskFilterState = {
  states: undefined,
  assignedToUserIds: undefined,
  agencyIds: undefined,
  leadAgentIds: undefined,
  taskDue: undefined,
  stages: undefined,
  addressSearchText: '',
};

const taskFiltersKey = 'taskFilters';

export const storeFilterState = (filters: TaskFilterState) => {
  try {
    const { agencyIds, ...storedFilters } = filters;
    localStorage.setItem(
      taskFiltersKey,
      JSON.stringify({ ...storedFilters, agencyValues: agencyIds })
    );
  } catch {
    // Optionally handle storage errors
  }
};

export const createInitialFilterState = (): TaskFilterState => {
  try {
    const storedFilterState = localStorage.getItem(taskFiltersKey);
    if (!storedFilterState) return defaultFilterState;

    const parsed = JSON.parse(storedFilterState) as StoredTaskFilterState;

    if (!parsed) return defaultFilterState;

    const addressSearchText = parsed.addressSearchText ?? defaultFilterState.addressSearchText;

    const states =
      parsed.states &&
      parsed.states.every((state: States) => AvailableStatesForTasks.includes(state))
        ? parsed.states
        : defaultFilterState.states;

    const assignedToUserIds = parsed.assignedToUserIds ?? defaultFilterState.assignedToUserIds;

    const stages =
      parsed.stages?.every((stage: Stages) => AvailableStageCategories.includes(stage)) &&
      parsed.stages
        ? parsed.stages
        : defaultFilterState.stages;

    const availableTaskDueTypes = Object.values(
      SearchTaskRequestTaskDue
    ) as SearchTaskRequestTaskDue[];

    const due =
      parsed.taskDue !== undefined && availableTaskDueTypes.includes(parsed.taskDue)
        ? parsed.taskDue
        : defaultFilterState.taskDue;

    return {
      ...defaultFilterState,
      addressSearchText,
      states: states,
      assignedToUserIds: assignedToUserIds,
      ...normalizeAgencyFilterState(parsed),
      stages: stages,
      taskDue: due,
    };
  } catch {
    return defaultFilterState;
  }
};
